
  <!--
 * 竖版
 * @LastEditTime: Mon Dec 23 2024 22:00:18 GMT+0800 (中国标准时间)
 -->
  <template>
  <div id="u_r_FJ4417" :class="[curLang]" class="u_r_FJ4417 route-m"  ><u_c_KSMY32></u_c_KSMY32><u_c_RZJQ61></u_c_RZJQ61><div id="u_c_13HN65"  :class="[`normal longscreen `,`u_c_13HN65`]" ><u_c_O3DB66></u_c_O3DB66><u_c_WZOJ19></u_c_WZOJ19><u_c_TH5620></u_c_TH5620><u_c_PO3569></u_c_PO3569><u_c_KNIA19></u_c_KNIA19><u_c_GWKK49></u_c_GWKK49></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Router from "@/hooks/router.js";
import { useRoute } from 'vue-router';
import bridge from "@/utils/sdkBridge.js";
import Language from "@/hooks/language.js";
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import u_c_KSMY32 from "@/components/u_c_KSMY32.vue";import u_c_RZJQ61 from "@/components/u_c_RZJQ61.vue";import u_c_O3DB66 from "@/components/u_c_O3DB66.vue";import u_c_WZOJ19 from "@/components/u_c_WZOJ19.vue";import u_c_TH5620 from "@/components/u_c_TH5620.vue";import u_c_PO3569 from "@/components/u_c_PO3569.vue";import u_c_KNIA19 from "@/components/u_c_KNIA19.vue";import u_c_GWKK49 from "@/components/u_c_GWKK49.vue"

    const { curLang, getLangTxt, langData } = Language();
    const compData = {};
    const ROUTER_DATA_LANG = {"ja-JP":{},"default":{}};
    const routerData = reactive(ROUTER_DATA_LANG[curLang] || ROUTER_DATA_LANG['ja-JP']||{});
    provide("routerData", routerData);
    const pageData = inject("pageData", {});
    const router = Router();
    const route = useRoute();
    let pagePlatform = "global"

    // 自定义setup - 开始
    /**
  竖版的缩放兼容
 */
const setPageScale = () => {
  let winWidth = window.innerWidth;
  let winHeight = window.innerHeight;
  let winRatio = winWidth / winHeight;
  if (winRatio <= 9 / 16) {
    let scale = Math.floor(winRatio * 1.8 * 100) / 100;
    updateScaleStyle(
      `.product-page .route-m .scaleww{transform:scale(${scale});transform-origin: 0% 0%;}`
    );
  } else {
    updateScaleStyle(``);
  }
};

const updateScaleStyle = (html) => {
  let styleElement = document.getElementById('scaleStyle');
  if (!styleElement) {
    styleElement = document.createElement('style');
    styleElement.innerHTML = html;
    styleElement.setAttribute('id', 'scaleStyle');
    document.head.appendChild(styleElement);
  }
  styleElement.innerHTML = html;
};

// window.addEventListener('resize', _.throttle(setPageScale, 500));

setPageScale();

if (window.innerWidth > window.innerHeight && router.hasRoute("index")) {
  let routerCount = router.router.getRoutes().length;
  if (routerCount >= 3) {
    router.gotoRouter("/");
  }
}
    // 自定义setup - 结束

  

</script>
<style lang="scss" scoped>

.ja-JP ::v-deep(.normal .scale8){
transform:scale(.8);

}

.ja-JP ::v-deep(.normal .popup){
background-color:rgba(0,0,0,0.8);
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
z-index:11;
display:flex;
justify-content:center;
align-items:center;

}

.ja-JP ::v-deep(.normal .popup-content){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723804069432-90.png);
background-size:cover;
background-repeat:no-repeat;
background-position:center;
width:9.73rem;
height:9.07rem;

}

.ja-JP ::v-deep(.normal .popup-close){
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723804069431-68.png);
background-size:contain;
width:0.65rem;
height:0.67rem;
z-index:9;

}

.ja-JP ::v-deep(.normal .popup-sure){
min-width:3.39rem;
height:1.07rem;
background:#cb7e11;
font-size:0.45rem;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
font-weight:bold;
border-radius:0.21rem;

}

.ja-JP ::v-deep(.normal .popup-txt){
font-size:0.35rem;
color:#7F534B;

}

.ja-JP ::v-deep(.normal .popup-title){
font-size:0.43rem;
color:#cb7e11;
text-align:center;

}

.ja-JP ::v-deep(.normal .role-select){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723804069421-95.png);
background-size:contain;
background-repeat:no-repeat;

}

.ja-JP ::v-deep(.normal .content){
color:#030303;

}

.ja-JP ::v-deep(.normal .btn-text){
color:#ffffff;

}

.ja-JP ::v-deep(.normal .transparent-popup-content){
font-size:0.29rem;
color:#ffffff;
text-align:center;
width:9.73rem;
height:100%;

}

.ja-JP ::v-deep(.normal .transparent-popup-close){
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723798489634-91.png);
background-size:contain;
width:0.40rem;
height:0.40rem;
z-index:9;
top:0.93rem;

}
#app {
  position: relative;
  width: 100%;
  height: 100%;
}

.customer-scroll-bar::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.customer-scroll-bar-mobile::-webkit-scrollbar {
  width: 12px;
  height: 4px;
}

.customer-scroll-bar-mobile::-webkit-scrollbar-thumb,
  .customer-scroll-bar::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}
.customer-scroll-bar-mobile::-webkit-scrollbar-track,
  .customer-scroll-bar::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.customer-scroll-bar-mobile::-webkit-scrollbar-thumb:hover,
  .customer-scroll-bar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.7);
}
.customer-scroll-bar-mobile::-webkit-scrollbar-thumb:active,
  .customer-scroll-bar::-webkit-scrollbar-thumb:active {
  background-color: rgba(0, 0, 0, 0.9);
}



.default ::v-deep(.normal .scale8){
transform:scale(.8);

}

.default ::v-deep(.normal .popup){
background-color:rgba(0,0,0,0.8);
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
z-index:11;
display:flex;
justify-content:center;
align-items:center;

}

.default ::v-deep(.normal .popup-content){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723804069432-90.png);
background-size:cover;
background-repeat:no-repeat;
background-position:center;
width:9.73rem;
height:9.07rem;

}

.default ::v-deep(.normal .popup-close){
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723804069431-68.png);
background-size:contain;
width:0.65rem;
height:0.67rem;
z-index:9;

}

.default ::v-deep(.normal .popup-sure){
min-width:3.39rem;
height:1.07rem;
background:#cb7e11;
font-size:0.45rem;
color:#ffffff;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
font-weight:bold;
border-radius:0.21rem;

}

.default ::v-deep(.normal .popup-txt){
font-size:0.35rem;
color:#7F534B;

}

.default ::v-deep(.normal .popup-title){
font-size:0.43rem;
color:#cb7e11;
text-align:center;

}

.default ::v-deep(.normal .role-select){
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723804069421-95.png);
background-size:contain;
background-repeat:no-repeat;

}

.default ::v-deep(.normal .content){
color:#030303;

}

.default ::v-deep(.normal .btn-text){
color:#ffffff;

}

.default ::v-deep(.normal .transparent-popup-content){
font-size:0.29rem;
color:#ffffff;
text-align:center;
width:9.73rem;
height:100%;

}

.default ::v-deep(.normal .transparent-popup-close){
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1723798489634-91.png);
background-size:contain;
width:0.40rem;
height:0.40rem;
z-index:9;
top:0.93rem;

}
#app {
  position: relative;
  width: 100%;
  height: 100%;
}

.customer-scroll-bar::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.customer-scroll-bar-mobile::-webkit-scrollbar {
  width: 12px;
  height: 4px;
}

.customer-scroll-bar-mobile::-webkit-scrollbar-thumb,
  .customer-scroll-bar::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}
.customer-scroll-bar-mobile::-webkit-scrollbar-track,
  .customer-scroll-bar::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.customer-scroll-bar-mobile::-webkit-scrollbar-thumb:hover,
  .customer-scroll-bar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.7);
}
.customer-scroll-bar-mobile::-webkit-scrollbar-thumb:active,
  .customer-scroll-bar::-webkit-scrollbar-thumb:active {
  background-color: rgba(0, 0, 0, 0.9);
}



.u_c_13HN65.normal{
position:absolute;
width:10.00rem;
top:0;
left:0;
height:100%;
right:0;
margin:auto;

}

</style>
